<template>
  <div id="app">
    <div class="appbg"></div>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view />
    <div class="loading" v-if="isLoading">
      <img src="@/assets/images/loading.gif" alt="" />
      <div class="bg"></div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  components: {},
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
  metaInfo() {
    return {
      title: '大立生鮮超市',
    };
  },
  created() {
    console.log(process.env.VUE_APP_APIURL);
    const vm = this;
    // localStorageOverWrite
    const localdata = JSON.parse(localStorage.getItem('cartdata'));
    const enableProduct = [];
    const disableProduct = [];
    if (localdata !== null && localdata.length !== 0) {
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/cart/expire_product`,
        type: 'POST',
        data: {
          cart: localdata,
        },
        success(res) {
          console.log('expire', res);
          const data = JSON.parse(res);
          console.log('expirdddddddddddddde', data);
          const newLocalStorage = [];
          const packages = data.package;
          const { product } = data;
          packages.forEach((item) => {
            newLocalStorage.push(item);
            if (item.expire === 1) {
              enableProduct.push(item);
            } else if (item.expire === 0) {
              disableProduct.push(item);
            }
          });
          product.forEach((item) => {
            newLocalStorage.push(item);
            if (item.expire === 1) {
              enableProduct.push(item);
            } else if (item.expire === 0) {
              disableProduct.push(item);
            }
          });
          console.log('結果');
          console.log(packages);
          console.log(product);
          vm.$store.commit('localStorageOverWrite', enableProduct);
          vm.$store.commit('setexpireProduct', disableProduct);
        },
      });
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/all.scss";
#app {
  // height: 200vh;
  // position: relative;
  height: 100vh;
  max-width: 1024px;
  margin: 0 auto;
  overflow-y: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: white;
}
.appbg{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  background: url('./assets/images/appbg.jpg');
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.container {
  display: flex;
}
.loading {
  z-index: 997;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  max-width: 1024px;
  height: 100vh;
  transform: translate(-50%, -50%);
  img {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    z-index: 999;
  }
  .bg {
    position: relative;
    z-index: 997;
    width: 100%;
    height: 100vh;
    max-width: 1024px;
    background: rgba(255, 255, 255, 0.75);
  }
}
</style>
